var map = {
	"./components/Pages/PageForbidden403": [
		"e14c",
		"chunk-2d224911"
	],
	"./components/Pages/PageForbidden403.vue": [
		"e14c",
		"chunk-2d224911"
	],
	"./components/Pages/PageNotFound404": [
		"4cda",
		"chunk-2d0cc462"
	],
	"./components/Pages/PageNotFound404.vue": [
		"4cda",
		"chunk-2d0cc462"
	],
	"./components/Pages/PageUnauthorized401": [
		"89a1",
		"chunk-2d0df7a7"
	],
	"./components/Pages/PageUnauthorized401.vue": [
		"89a1",
		"chunk-2d0df7a7"
	],
	"./components/Widgets/Banner/Banner": [
		"a664",
		"chunk-2d208a69"
	],
	"./components/Widgets/Banner/Banner.vue": [
		"a664",
		"chunk-2d208a69"
	],
	"./components/Widgets/Blog/BlogDetail": [
		"9a80",
		"chunk-c64b5290"
	],
	"./components/Widgets/Blog/BlogDetail.vue": [
		"9a80",
		"chunk-c64b5290"
	],
	"./components/Widgets/Blog/BlogList": [
		"7a48",
		"chunk-4a165984"
	],
	"./components/Widgets/Blog/BlogList.vue": [
		"7a48",
		"chunk-4a165984"
	],
	"./components/Widgets/Blog/templates/BulletsList": [
		"6909",
		"chunk-576c14f0"
	],
	"./components/Widgets/Blog/templates/BulletsList.vue": [
		"6909",
		"chunk-576c14f0"
	],
	"./components/Widgets/Blog/templates/Heading": [
		"a562",
		"chunk-2d2086a6"
	],
	"./components/Widgets/Blog/templates/Heading.vue": [
		"a562",
		"chunk-2d2086a6"
	],
	"./components/Widgets/Blog/templates/Paragraph": [
		"154c",
		"chunk-2d0ab4c9"
	],
	"./components/Widgets/Blog/templates/Paragraph.vue": [
		"154c",
		"chunk-2d0ab4c9"
	],
	"./components/Widgets/Crypto/Charts/TradingViewCandles": [
		"d210",
		"chunk-2d21d7e3"
	],
	"./components/Widgets/Crypto/Charts/TradingViewCandles.vue": [
		"d210",
		"chunk-2d21d7e3"
	],
	"./components/Widgets/Crypto/Dashboard/templates/MainCryptosList": [
		"68d8",
		"chunk-d28347d8"
	],
	"./components/Widgets/Crypto/Dashboard/templates/MainCryptosList.vue": [
		"68d8",
		"chunk-d28347d8"
	],
	"./components/Widgets/Crypto/Dashboard/templates/MyCryptos": [
		"72f6",
		"chunk-4f2602c1",
		"chunk-1952bd16",
		"chunk-7524b446"
	],
	"./components/Widgets/Crypto/Dashboard/templates/MyCryptos.vue": [
		"72f6",
		"chunk-4f2602c1",
		"chunk-1952bd16",
		"chunk-7524b446"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/EditMyCryptos": [
		"6377",
		"chunk-4f2602c1",
		"chunk-1952bd16"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/EditMyCryptos.vue": [
		"6377",
		"chunk-4f2602c1",
		"chunk-1952bd16"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/ImportCrypto": [
		"4b27",
		"chunk-4f2602c1",
		"chunk-2d0cba69"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/ImportCrypto.vue": [
		"4b27",
		"chunk-4f2602c1",
		"chunk-2d0cba69"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/List": [
		"f24e",
		"chunk-9c105a08"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/List.vue": [
		"f24e",
		"chunk-9c105a08"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/ListFilters": [
		"b05c",
		"chunk-2d20e852"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/ListFilters.vue": [
		"b05c",
		"chunk-2d20e852"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/PacksBalance": [
		"6582",
		"chunk-532a4958"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/PacksBalance.vue": [
		"6582",
		"chunk-532a4958"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/Pagination": [
		"8833",
		"chunk-2d0dee56"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/Pagination.vue": [
		"8833",
		"chunk-2d0dee56"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/SyncFromWallet": [
		"f837",
		"chunk-4f2602c1",
		"chunk-2d22d76c"
	],
	"./components/Widgets/Crypto/Dashboard/templates/templates/SyncFromWallet.vue": [
		"f837",
		"chunk-4f2602c1",
		"chunk-2d22d76c"
	],
	"./components/Widgets/Crypto/Packs/Packs": [
		"2520",
		"chunk-4f2602c1",
		"chunk-66c536b3",
		"chunk-0f8a1c13"
	],
	"./components/Widgets/Crypto/Packs/Packs.vue": [
		"2520",
		"chunk-4f2602c1",
		"chunk-66c536b3",
		"chunk-0f8a1c13"
	],
	"./components/Widgets/Crypto/Packs/templates/AddCryptoToPack": [
		"d23c",
		"chunk-4f2602c1",
		"chunk-66c536b3"
	],
	"./components/Widgets/Crypto/Packs/templates/AddCryptoToPack.vue": [
		"d23c",
		"chunk-4f2602c1",
		"chunk-66c536b3"
	],
	"./components/Widgets/Crypto/Packs/templates/AddPack": [
		"8b44",
		"chunk-4f2602c1",
		"chunk-803309d4"
	],
	"./components/Widgets/Crypto/Packs/templates/AddPack.vue": [
		"8b44",
		"chunk-4f2602c1",
		"chunk-803309d4"
	],
	"./components/Widgets/Crypto/Packs/templates/DeleteCrypto": [
		"72c2",
		"chunk-2d0d6940"
	],
	"./components/Widgets/Crypto/Packs/templates/DeleteCrypto.vue": [
		"72c2",
		"chunk-2d0d6940"
	],
	"./components/Widgets/Crypto/Packs/templates/DeletePack": [
		"1ae0",
		"chunk-dcd2e454"
	],
	"./components/Widgets/Crypto/Packs/templates/DeletePack.vue": [
		"1ae0",
		"chunk-dcd2e454"
	],
	"./components/Widgets/Crypto/Swap/Swap": [
		"c183",
		"chunk-90cfcebc"
	],
	"./components/Widgets/Crypto/Swap/Swap.vue": [
		"c183",
		"chunk-90cfcebc"
	],
	"./components/Widgets/Crypto/Swap/templates/TokensList": [
		"ba8a",
		"chunk-951b4526"
	],
	"./components/Widgets/Crypto/Swap/templates/TokensList.vue": [
		"ba8a",
		"chunk-951b4526"
	],
	"./components/Widgets/Crypto/Tokens/CardanoPairs": [
		"6863",
		"chunk-2d0d05f5"
	],
	"./components/Widgets/Crypto/Tokens/CardanoPairs.vue": [
		"6863",
		"chunk-2d0d05f5"
	],
	"./components/Widgets/Crypto/Tokens/HotPairs": [
		"3b34",
		"chunk-4b341708"
	],
	"./components/Widgets/Crypto/Tokens/HotPairs.vue": [
		"3b34",
		"chunk-4b341708"
	],
	"./components/Widgets/Crypto/Tokens/RankingGainersLosers": [
		"8072",
		"chunk-8c6ea2f4"
	],
	"./components/Widgets/Crypto/Tokens/RankingGainersLosers.vue": [
		"8072",
		"chunk-8c6ea2f4"
	],
	"./components/Widgets/Crypto/Tokens/TokenDetail": [
		"c791",
		"chunk-2d217742"
	],
	"./components/Widgets/Crypto/Tokens/TokenDetail.vue": [
		"c791",
		"chunk-2d217742"
	],
	"./components/Widgets/Crypto/Tokens/Trending": [
		"42fa",
		"chunk-2d0c0caf"
	],
	"./components/Widgets/Crypto/Tokens/Trending.vue": [
		"42fa",
		"chunk-2d0c0caf"
	],
	"./components/Widgets/Faqs/Faqs": [
		"b71a",
		"chunk-2cc479be"
	],
	"./components/Widgets/Faqs/Faqs.vue": [
		"b71a",
		"chunk-2cc479be"
	],
	"./components/Widgets/Footer/Footer": [
		"31a9"
	],
	"./components/Widgets/Footer/Footer.vue": [
		"31a9"
	],
	"./components/Widgets/HTMLDisplay/HTMLDisplay": [
		"370d",
		"chunk-2d0ba48e"
	],
	"./components/Widgets/HTMLDisplay/HTMLDisplay.vue": [
		"370d",
		"chunk-2d0ba48e"
	],
	"./components/Widgets/Header/ConnectWallet": [
		"3286"
	],
	"./components/Widgets/Header/ConnectWallet.vue": [
		"3286"
	],
	"./components/Widgets/Header/Header": [
		"6a4c"
	],
	"./components/Widgets/Header/Header.vue": [
		"6a4c"
	],
	"./components/Widgets/Header/SwapChain": [
		"1622"
	],
	"./components/Widgets/Header/SwapChain.vue": [
		"1622"
	],
	"./components/Widgets/Header/SwapChainList": [
		"5b5e"
	],
	"./components/Widgets/Header/SwapChainList.vue": [
		"5b5e"
	],
	"./components/Widgets/LanguageSelector/LanguageSelector": [
		"13a9",
		"chunk-2d0ab290"
	],
	"./components/Widgets/LanguageSelector/LanguageSelector.vue": [
		"13a9",
		"chunk-2d0ab290"
	],
	"./components/Widgets/ListWithFilters/ListWithFilters": [
		"e432",
		"chunk-4166b4ab"
	],
	"./components/Widgets/ListWithFilters/ListWithFilters.vue": [
		"e432",
		"chunk-4166b4ab"
	],
	"./components/Widgets/ListWithFilters/templates/List": [
		"3c46",
		"chunk-2d0c4a08"
	],
	"./components/Widgets/ListWithFilters/templates/List.vue": [
		"3c46",
		"chunk-2d0c4a08"
	],
	"./components/Widgets/ListWithFilters/templates/ListFilters": [
		"0b4d",
		"chunk-2d0ae958"
	],
	"./components/Widgets/ListWithFilters/templates/ListFilters.vue": [
		"0b4d",
		"chunk-2d0ae958"
	],
	"./components/Widgets/ListWithFilters/templates/Pagination": [
		"b1a2",
		"chunk-2d20f136"
	],
	"./components/Widgets/ListWithFilters/templates/Pagination.vue": [
		"b1a2",
		"chunk-2d20f136"
	],
	"./components/Widgets/Login/ForgotPassword": [
		"30a0",
		"chunk-4f2602c1",
		"chunk-046ac79a"
	],
	"./components/Widgets/Login/ForgotPassword.vue": [
		"30a0",
		"chunk-4f2602c1",
		"chunk-046ac79a"
	],
	"./components/Widgets/Login/Login": [
		"b90d",
		"chunk-4f2602c1",
		"chunk-b568460c"
	],
	"./components/Widgets/Login/Login.vue": [
		"b90d",
		"chunk-4f2602c1",
		"chunk-b568460c"
	],
	"./components/Widgets/Login/SignUp": [
		"126c",
		"chunk-4f2602c1",
		"chunk-be424dae"
	],
	"./components/Widgets/Login/SignUp.vue": [
		"126c",
		"chunk-4f2602c1",
		"chunk-be424dae"
	],
	"./components/Widgets/Promotional/HighlightedInfo": [
		"bcc4",
		"chunk-60c38aa7"
	],
	"./components/Widgets/Promotional/HighlightedInfo.vue": [
		"bcc4",
		"chunk-60c38aa7"
	],
	"./components/Widgets/Promotional/HighlightedSideImage": [
		"58c5",
		"chunk-56d86ef8"
	],
	"./components/Widgets/Promotional/HighlightedSideImage.vue": [
		"58c5",
		"chunk-56d86ef8"
	],
	"./components/Widgets/Shared/HelpInfo": [
		"d609",
		"chunk-2d21e6d1"
	],
	"./components/Widgets/Shared/HelpInfo.vue": [
		"d609",
		"chunk-2d21e6d1"
	],
	"./components/Widgets/Shared/Modal": [
		"fedc"
	],
	"./components/Widgets/Shared/Modal.vue": [
		"fedc"
	],
	"./components/Widgets/Shared/WidgetModel": [
		"555e"
	],
	"./components/Widgets/Shared/WidgetModel.vue": [
		"555e"
	],
	"./components/Widgets/SideNavigation/SideNavigation": [
		"4083"
	],
	"./components/Widgets/SideNavigation/SideNavigation.vue": [
		"4083"
	],
	"./components/componentsDefinitions": [
		"fded"
	],
	"./components/componentsDefinitions.js": [
		"fded"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "92c0";
module.exports = webpackAsyncContext;